'use client'

import { usePricesStore } from '../../context/PricesProvider'
import type { Price } from '../../store/pricesStore/pricesStore'
import { getWrapperClassname } from '../../utils/getStyles/getStyles'
import { DiscountRate } from '../DiscountRate/DiscountRate'
import { DiscountRateWrapper } from '../DiscountRate/DiscountRateWrapper/DiscountRateWrapper'
import { ExtraInfo } from '../ExtraInfo/ExtraInfo'

interface PriceInfoProps {
	readonly crossedOut: Price[]
	readonly children: React.ReactNode
}

export const PriceInfo = ({ crossedOut, children }: PriceInfoProps) => {
	const {
		horizontal = false,
		align = 'start',
		reverse = false,
		priceClasses,
		discountRate,
		showDiscount = false,
		price,
		country: { locale },
	} = usePricesStore()

	const discountText = discountRate
		? new Intl.NumberFormat(locale, {
				style: 'percent',
			}).format(-(discountRate / 100))
		: ''

	const shouldShowDiscount = showDiscount && Boolean(discountText)

	const pricesHistory = [...crossedOut, price]

	const DiscountRateComponent = <DiscountRate discountText={discountText} />

	const ExtraInfoComponent = (
		<ExtraInfo
			pricesHistory={pricesHistory}
			shouldShowDiscount={shouldShowDiscount}
			crossedOut={crossedOut}
		/>
	)

	if (!horizontal) {
		return (
			<>
				<div
					className={getWrapperClassname({
						horizontal,
						align,
						reverse,
						classes: priceClasses,
					})}
				>
					{children}
				</div>
				<DiscountRateWrapper shouldShowDiscount={shouldShowDiscount}>
					{ExtraInfoComponent}
					{DiscountRateComponent}
				</DiscountRateWrapper>
			</>
		)
	}

	return (
		<div
			className={getWrapperClassname({
				horizontal,
				align,
				reverse,
				classes: priceClasses,
			})}
		>
			{ExtraInfoComponent}
			{children}
			<DiscountRateWrapper shouldShowDiscount={shouldShowDiscount}>
				{DiscountRateComponent}
			</DiscountRateWrapper>
		</div>
	)
}
